(() => {
  if (window.__agStickyConfiguratorBarInitialized) return;
  window.__agStickyConfiguratorBarInitialized = true;

  const ROOT_SELECTOR = '[data-ag-sticky-configurator-bar]';

  const resolveObservedSection = (root) => {
    const explicitSelector = (root.dataset.observeSelector || '').trim();
    if (explicitSelector) {
      const explicitMatch = document.querySelector(explicitSelector);
      if (explicitMatch) return explicitMatch;
    }

    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const section = productInfo.closest('.shopify-section');
      if (section) return section;
    }

    return document.querySelector('[id$="__main"]');
  };

  const setVisible = (root, visible) => {
    root.classList.toggle('ag-sticky-configurator-bar--visible', Boolean(visible));
    root.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const bindDirectAddToCart = (root) => {
    if (root.dataset.agStickyAction !== 'add-to-cart') return;

    const stickyButton = root.querySelector('[data-ag-sticky-add-to-cart]');
    if (!(stickyButton instanceof HTMLButtonElement)) return;

    const handleClick = () => {
      const mainAddButton = document.querySelector('product-info .product-form__submit[name="add"]');
      if (!(mainAddButton instanceof HTMLButtonElement) || mainAddButton.disabled) return;
      mainAddButton.click();
    };

    stickyButton.addEventListener('click', handleClick);
    root.__agStickyDirectAddClick = handleClick;
  };

  const cleanupRoot = (root) => {
    if (!(root instanceof HTMLElement)) return;

    if (root.__agStickyConfiguratorObserver && typeof root.__agStickyConfiguratorObserver.disconnect === 'function') {
      root.__agStickyConfiguratorObserver.disconnect();
    }
    root.__agStickyConfiguratorObserver = null;

    if (typeof root.__agStickyFallbackUpdate === 'function') {
      window.removeEventListener('scroll', root.__agStickyFallbackUpdate);
      window.removeEventListener('resize', root.__agStickyFallbackUpdate);
    }
    root.__agStickyFallbackUpdate = null;

    const stickyButton = root.querySelector('[data-ag-sticky-add-to-cart]');
    if (stickyButton && typeof root.__agStickyDirectAddClick === 'function') {
      stickyButton.removeEventListener('click', root.__agStickyDirectAddClick);
    }
    root.__agStickyDirectAddClick = null;

    root.dataset.agStickyConfiguratorBarInit = 'false';
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.agStickyConfiguratorBarInit === 'true') return;
    root.dataset.agStickyConfiguratorBarInit = 'true';
    bindDirectAddToCart(root);

    const observedSection = resolveObservedSection(root);
    if (!(observedSection instanceof Element)) {
      console.warn('[AG Sticky Configurator Bar] main product section not found');
      return;
    }

    setVisible(root, false);

    if (typeof IntersectionObserver === 'undefined') {
      const fallbackUpdate = () => {
        const rect = observedSection.getBoundingClientRect();
        const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        setVisible(root, !isVisible);
      };
      fallbackUpdate();
      window.addEventListener('scroll', fallbackUpdate, { passive: true });
      window.addEventListener('resize', fallbackUpdate);
      root.__agStickyFallbackUpdate = fallbackUpdate;
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        setVisible(root, !entry.isIntersecting);
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe(observedSection);
    root.__agStickyConfiguratorObserver = observer;
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.matches(ROOT_SELECTOR)) {
      initRoot(event.target);
      return;
    }
    event.target.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.matches(ROOT_SELECTOR)) {
      cleanupRoot(event.target);
      return;
    }
    event.target.querySelectorAll?.(ROOT_SELECTOR).forEach(cleanupRoot);
  });
})();
